module.exports = __webpack_public_path__ + "img/get-advice-step.088d5b27.svg";